var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenRoundedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EBFBFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_3716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7109 22H22.2891C21.5784 22 21 22.5784 21 23.2891V36.0938C21 36.8045 21.5784 37.3828 22.2891 37.3828H41.7109C42.4216 37.3828 43 36.8045 43 36.0938V23.2891C43 22.5784 42.4216 22 41.7109 22Z",
    fill: "#00A9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8749 40.5625H35.3944V38.6719H28.6054V40.5625H25.1249C24.7691 40.5625 24.4804 40.8513 24.4804 41.207C24.4804 41.5628 24.7691 41.8516 25.1249 41.8516H38.8749C39.2307 41.8516 39.5194 41.5628 39.5194 41.207C39.5194 40.8513 39.2307 40.5625 38.8749 40.5625Z",
    fill: "#00A9B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_3716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenRoundedGreen);
export default __webpack_public_path__ + "static/media/screen-rounded-green.581961d8bcbc73238fdf414813383c06.svg";
export { ForwardRef as ReactComponent };